/**
 * Buckbootz - No Default Variant Selection
 * Zorgt ervoor dat er geen maat standaard geselecteerd is bij het laden van de productpagina.
 * Gebruikers moeten bewust een maat kiezen voordat ze kunnen toevoegen aan de winkelwagen.
 */

(function () {
  'use strict';

  function clearDefaultVariantSelection() {
    const variantSelects = document.querySelector('variant-selects');
    if (!variantSelects) return;

    // Deselect alle radio buttons (pill/button picker)
    const radioInputs = variantSelects.querySelectorAll('input[type="radio"]');
    radioInputs.forEach((input) => {
      input.checked = false;
    });

    // Reset alle select dropdowns naar lege optie
    const selectInputs = variantSelects.querySelectorAll('select');
    selectInputs.forEach((select) => {
      // Voeg een lege placeholder optie toe als die er nog niet is
      if (!select.querySelector('option[value=""]')) {
        const placeholder = document.createElement('option');
        placeholder.value = '';
        placeholder.textContent = '-- Select size --';
        placeholder.selected = true;
        placeholder.disabled = true;
        select.insertBefore(placeholder, select.firstChild);
      } else {
        select.value = '';
      }
    });

    // Update de geselecteerde waarde labels
    const selectedValueLabels = variantSelects.querySelectorAll('[data-selected-value]');
    selectedValueLabels.forEach((label) => {
      label.textContent = '';
    });

    // Disable de add-to-cart knop totdat een maat is gekozen
    const addToCartBtn = document.querySelector('#ProductSubmitButton-' + variantSelects.dataset.section + '__main, [id^="ProductSubmitButton"]');
    if (addToCartBtn) {
      addToCartBtn.disabled = true;
      addToCartBtn.setAttribute('data-bb-awaiting-size', 'true');

      // Toon een hint tekst
      const btnText = addToCartBtn.querySelector('[name="add"]') || addToCartBtn;
      if (addToCartBtn.getAttribute('data-bb-original-text') === null) {
        addToCartBtn.setAttribute('data-bb-original-text', addToCartBtn.textContent.trim());
      }
    }

    // Luister naar variant selectie om de knop weer in te schakelen
    variantSelects.addEventListener('change', function onVariantChange() {
      const hasSelection = Array.from(variantSelects.querySelectorAll('input[type="radio"]:checked, select')).some((el) => {
        if (el.tagName === 'SELECT') return el.value !== '';
        return true; // radio is checked
      });

      if (hasSelection && addToCartBtn) {
        addToCartBtn.removeAttribute('data-bb-awaiting-size');
        // Knop wordt door Shopify zelf beheerd na variant selectie
      }
    });
  }

  // Voer uit zodra de DOM klaar is
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', clearDefaultVariantSelection);
  } else {
    clearDefaultVariantSelection();
  }

  // Ook uitvoeren na Shopify sectie renders (voor quick-add etc.)
  document.addEventListener('shopify:section:load', clearDefaultVariantSelection);
})();
